export default {
    getUserStatistics: (state) => {
        return state.documents;
    },
}